// Colonnes des kanbans, priorités, rôles : clés identiques au backend
// (backend/src/constants.js), libellés ici.
export const STATUTS_PROJET = [
  { cle: 'a_lancer', libelle: 'À lancer' },
  { cle: 'en_cours', libelle: 'En cours' },
  { cle: 'en_pause', libelle: 'En pause' },
  { cle: 'termine', libelle: 'Terminé' },
];

export const STATUTS_TACHE = [
  { cle: 'a_faire', libelle: 'À faire' },
  { cle: 'en_cours', libelle: 'En cours' },
  { cle: 'en_revue', libelle: 'En revue' },
  { cle: 'termine', libelle: 'Terminé' },
];

// Faible par défaut.
export const PRIORITES = [
  { cle: 'haute', libelle: 'Haute', classe: 'badge-erreur' },
  { cle: 'moyenne', libelle: 'Moyenne', classe: 'badge-alerte' },
  { cle: 'faible', libelle: 'Faible', classe: 'badge-neutre' },
];

export const ROLES = [
  { cle: 'membre', libelle: 'Membre', aide: 'voit ses projets et ses tâches' },
  { cle: 'admin', libelle: 'Administrateur', aide: 'voit tout, accède aux Paramètres' },
];

export const libelle = (liste, cle) => liste.find((x) => x.cle === cle)?.libelle || cle;
